let showLoader: () => void = () => {};
let hideLoader: () => void = () => {};

export const loaderController = {
  setHooks(show: () => void, hide: () => void) {
    showLoader = show;
    hideLoader = hide;
  },
  show() {
    showLoader();
  },
  hide() {
    hideLoader();
  },
};
